<!-- 组卷中心呢-试题筛选 -->
<template>
    <div class="base-paper-container" v-loading="loading">
        <div class="paper-head-box">
            <div class="paper-head-container">
                <div class="l-side-paper-container">
                    <svg t="1775717777561" @click="backResourceCenter('/hyedu/resource')" style="margin-top: 9px;" class="icon cursor" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5353" width="32" height="32"><path d="M404.032 233.344a32 32 0 1 1 45.248 45.312L247.872 480h605.44a32 32 0 0 1 31.488 26.24l0.512 5.76a32 32 0 0 1-32 32h-605.44l201.408 201.344a32 32 0 0 1 3.712 40.832l-3.712 4.48a32 32 0 0 1-45.248 0l-256-256-0.64-0.896-1.216-1.152-0.896-1.344-0.96-1.088-0.64-1.152-0.64-0.896-0.64-1.344-0.832-1.472-0.32-1.152-0.64-1.024-0.256-1.536-0.64-1.472-0.192-1.472-0.32-0.896-0.064-1.216-0.384-1.792V513.28L138.752 512l0.128-1.28v-1.472l0.32-1.856V506.24l0.384-0.96 0.192-1.408 0.64-1.536 0.32-1.472 0.576-1.088 0.32-1.088 0.896-1.536 0.576-1.28 0.64-0.96 0.64-1.088 0.96-1.152 0.896-1.28 1.216-1.216 0.64-0.832 256-256z" fill="#0d55a4" p-id="5354"></path></svg>
                </div>
                <div class="mid-paper-container">{{periodName}}</div>
                <div class="r-side-paper-container cursor">
                    <el-avatar style="margin-top: 7px;" :size="36" :src="userInfo.avatar + '?_=' + Date.now()" />
                </div>
            </div>
        </div>
        <!--   页面主题  -->
        <div class="paper-container">
            <div class="l-paper-container">
                <el-scrollbar class="l-scrollbar-container">
                    <div class="subject-title">学科：</div>
                    <div class="subject-box-container">
                        <div :class="item.subjectNo===subjectNo?'subject-one-active':'subject-one'"
                             v-for="item in subjectList" @click="changeSubject(item)" :key="item">
                            {{item.subjectShortName}}
                        </div>
                    </div>
                    <!-- 教材选题-版本信息 -->
                    <el-popover v-if="paperMode===1" placement="bottom-start" trigger="hover" :width="'900'">
                        <div class="edition-title">教材版本</div>
                        <div class="edition-grade-container">
                            <div :class="this.editionNo===item.editionNo?'edition-grade-item-active':'edition-grade-item'" v-for="item in editionList" @click="changeEdition(item)" :key="item">
                                {{item.editionName}}
                            </div>
                        </div>
                        <div class="edition-divider"></div>
                        <div class="edition-title">年级 </div>
                        <div class="edition-grade-container">
                            <div :class="this.gradeNo===item.gradeNo&&this.termNo===item.termNo?'edition-grade-item-active':'edition-grade-item'" v-for="item in gradeList" @click="changeGrade(item)" :key="item">
                                {{item.gradeOtherName}}
                            </div>
                        </div>
                        <template #reference>
                            <div class="edition-container">
                                <div class="l-edition-container">{{editionName}}：{{gradeOtherName}}</div>
                                <div class="r-edition-container">
                                    <svg t="1776059995661" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8230" width="32" height="32"><path d="M512 956.9792a448.6656 448.6656 0 1 1 448.6656-448.6656A449.1776 449.1776 0 0 1 512 956.9792z m0-835.8912a387.2256 387.2256 0 1 0 387.2256 387.2256A387.6352 387.6352 0 0 0 512 121.088z" fill="#0d55a4" p-id="8231"></path><path d="M327.68 472.1152h368.64a30.72 30.72 0 0 0 26.4704-46.08L665.6 328.3456a30.72 30.72 0 1 0-52.992 31.1296l30.1056 51.2H327.68a30.72 30.72 0 0 0 0 61.44zM696.32 556.6464H327.68a30.72 30.72 0 0 0-26.4704 46.08l57.2928 97.28a30.72 30.72 0 1 0 52.992-31.1296l-30.1056-51.2H696.32a30.72 30.72 0 0 0 0-61.44z" fill="#0d55a4" p-id="8232"></path></svg>
                                </div>
                            </div>
                        </template>
                    </el-popover>
                    <!-- 教材选题-章节信息 -->
                    <div class="category-container" v-if="paperMode===1">
                        <el-tree
                          :show-expand="true"
                          :data="categoryList"
                          :props="categoryProps" >
                            <template #default="{ node, data }">
                                <div class="category-tree-node" :title="data.categoryName">
                                    <i v-if="!data.children">
                                        <svg t="1776069011157" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2100" width="16" height="16"><path d="M256 448m64 0l384 0q64 0 64 64l0 0q0 64-64 64l-384 0q-64 0-64-64l0 0q0-64 64-64Z" fill="#ffffff" p-id="2101"></path><path d="M256 0h512a256 256 0 0 1 256 256v512a256 256 0 0 1-256 256H256a256 256 0 0 1-256-256V256a256 256 0 0 1 256-256z m0 64a192 192 0 0 0-192 192v512a192 192 0 0 0 192 192h512a192 192 0 0 0 192-192V256a192 192 0 0 0-192-192H256z" fill="#ffffff" p-id="2102"></path></svg>
                                    </i>
                                    <i v-if="node.expanded&&data.children">
                                        <svg t="1776069011157" style="margin-top: 3px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2100" width="16" height="16"><path d="M256 448m64 0l384 0q64 0 64 64l0 0q0 64-64 64l-384 0q-64 0-64-64l0 0q0-64 64-64Z" fill="#0d55a4" p-id="2101"></path><path d="M256 0h512a256 256 0 0 1 256 256v512a256 256 0 0 1-256 256H256a256 256 0 0 1-256-256V256a256 256 0 0 1 256-256z m0 64a192 192 0 0 0-192 192v512a192 192 0 0 0 192 192h512a192 192 0 0 0 192-192V256a192 192 0 0 0-192-192H256z" fill="#0d55a4" p-id="2102"></path></svg>
                                    </i>
                                    <i v-if="!node.expanded&&data.children&&data.children.length>0">
                                        <svg t="1776068985277" style="margin-top: 3px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1795" width="16" height="16"><path d="M468.864 469.504V299.072a38.4 38.4 0 1 1 76.8 0v170.432h170.432a38.4 38.4 0 1 1 0 76.8H545.664V716.8a38.4 38.4 0 1 1-76.8 0V546.304H298.432a38.4 38.4 0 1 1 0-76.8h170.432zM172.8 6.4h678.4a166.4 166.4 0 0 1 166.4 166.4v678.4a166.4 166.4 0 0 1-166.4 166.4H172.8a166.4 166.4 0 0 1-166.4-166.4V172.8A166.4 166.4 0 0 1 172.8 6.4z m0 76.8a89.6 89.6 0 0 0-89.6 89.6v678.4a89.6 89.6 0 0 0 89.6 89.6h678.4a89.6 89.6 0 0 0 89.6-89.6V172.8a89.6 89.6 0 0 0-89.6-89.6H172.8z" fill="#0d55a4" p-id="1796"></path></svg>
                                    </i>
                                    <div @click="handleCategoryNodeClick(data)" :class="selCategoryId===data.categoryId?'category-span-active':'category-span'">{{data.categoryName}}</div>
                                </div>
                            </template>
                        </el-tree>
                    </div>
                    <!-- 知识点选题 -->
                    <div class="edition-container" v-if="paperMode===2">
                        <div class="l-edition-container">知识点列表</div>
                        <div class="r-edition-container">
                        </div>
                    </div>
                    <div class="category-container" v-if="paperMode===2">
                        <el-tree
                          :show-expand="true"
                          :data="pointList"
                          :props="pointProps">
                            <template #default="{ node, data }">
                                <div class="category-tree-node" :title="data.name">
                                    <i v-if="!data.children">
                                        <svg t="1776069011157" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2100" width="16" height="16"><path d="M256 448m64 0l384 0q64 0 64 64l0 0q0 64-64 64l-384 0q-64 0-64-64l0 0q0-64 64-64Z" fill="#ffffff" p-id="2101"></path><path d="M256 0h512a256 256 0 0 1 256 256v512a256 256 0 0 1-256 256H256a256 256 0 0 1-256-256V256a256 256 0 0 1 256-256z m0 64a192 192 0 0 0-192 192v512a192 192 0 0 0 192 192h512a192 192 0 0 0 192-192V256a192 192 0 0 0-192-192H256z" fill="#ffffff" p-id="2102"></path></svg>
                                    </i>
                                    <i v-if="node.expanded&&data.children">
                                        <svg t="1776069011157" style="margin-top: 3px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2100" width="16" height="16"><path d="M256 448m64 0l384 0q64 0 64 64l0 0q0 64-64 64l-384 0q-64 0-64-64l0 0q0-64 64-64Z" fill="#0d55a4" p-id="2101"></path><path d="M256 0h512a256 256 0 0 1 256 256v512a256 256 0 0 1-256 256H256a256 256 0 0 1-256-256V256a256 256 0 0 1 256-256z m0 64a192 192 0 0 0-192 192v512a192 192 0 0 0 192 192h512a192 192 0 0 0 192-192V256a192 192 0 0 0-192-192H256z" fill="#0d55a4" p-id="2102"></path></svg>
                                    </i>
                                    <i v-if="!node.expanded&&data.children&&data.children.length>0">
                                        <svg t="1776068985277" style="margin-top: 3px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1795" width="16" height="16"><path d="M468.864 469.504V299.072a38.4 38.4 0 1 1 76.8 0v170.432h170.432a38.4 38.4 0 1 1 0 76.8H545.664V716.8a38.4 38.4 0 1 1-76.8 0V546.304H298.432a38.4 38.4 0 1 1 0-76.8h170.432zM172.8 6.4h678.4a166.4 166.4 0 0 1 166.4 166.4v678.4a166.4 166.4 0 0 1-166.4 166.4H172.8a166.4 166.4 0 0 1-166.4-166.4V172.8A166.4 166.4 0 0 1 172.8 6.4z m0 76.8a89.6 89.6 0 0 0-89.6 89.6v678.4a89.6 89.6 0 0 0 89.6 89.6h678.4a89.6 89.6 0 0 0 89.6-89.6V172.8a89.6 89.6 0 0 0-89.6-89.6H172.8z" fill="#0d55a4" p-id="1796"></path></svg>
                                    </i>
                                    <div @click="handlePointNodeClick(data)" :class="selPointNo===data.no?'category-span-active':'category-span'">{{data.name}}</div>
                                </div>
                            </template>
                        </el-tree>
                    </div>
                </el-scrollbar>
            </div>
            <div class="r-paper-container">
                <!-- 选题模式 -->
                 <div class="paper-nav-container">
                    <div :class="paperMode===1?'paper-nav-item-active':'paper-nav-item'" @click="changePaperMode(1)">章节选题</div>
                    <div :class="paperMode===2?'paper-nav-item-active':'paper-nav-item'" @click="changePaperMode(2)">知识点选题</div>
                 </div>
                <!-- 试题筛选 -->
                <el-scrollbar class="r-scrollbar-container">
                    <!-- 题型 -->
                    <div class="ques-condition-container" v-if="quesTypeList&&quesTypeList.length>0">
                        <div class="ques-condition-title">题型：</div>
                        <div class="ques-condition-content">
                            <div @click="changeQuesType(0)" :class="quesType===0?'ques-condition-item-active':'ques-condition-item'">全部</div>
                            <div @click="changeQuesType(item.key)" :class="quesType===item.key?'ques-condition-item-active':'ques-condition-item'" v-for="item in quesTypeList" :key="item">{{item.value}}</div>
                        </div>
                    </div>
                    <!-- 难度 -->
                    <div class="ques-condition-container" v-if="quesDegreeList&&quesDegreeList.length>0">
                        <div class="ques-condition-title">难度：</div>
                        <div class="ques-condition-content">
                            <div @click="changeDegreeType(0)" :class="degreeType===0?'ques-condition-item-active':'ques-condition-item'">全部</div>
                            <div @click="changeDegreeType(item.value)" :class="degreeType===item.value?'ques-condition-item-active':'ques-condition-item'" v-for="item in quesDegreeList" :key="item">{{item.name}}</div>
                        </div>
                    </div>
                    <!-- 题类 -->
                    <div class="ques-condition-container" v-if="quesDegreeList&&quesDegreeList.length>0">
                        <div class="ques-condition-title">题类：</div>
                        <div class="ques-condition-content">
                            <div @click="changeQuesClassify(0)" :class="quesClassify==='True'?'ques-condition-item-active':'ques-condition-item'">全部</div>
                            <div @click="changeQuesClassify(1)" :class="queryQues.rc==='True'?'ques-condition-item-active':'ques-condition-item'">常考题</div>
                            <div @click="changeQuesClassify(2)" :class="queryQues.ec==='True'?'ques-condition-item-active':'ques-condition-item'">易错题</div>
                            <div @click="changeQuesClassify(3)" :class="queryQues.gc==='True'?'ques-condition-item-active':'ques-condition-item'">好题</div>
                            <div @click="changeQuesClassify(4)" :class="queryQues.yc==='True'?'ques-condition-item-active':'ques-condition-item'">压轴题</div>
                            <div @click="changeQuesClassify(5)" :class="queryQues.sc==='True'?'ques-condition-item-active':'ques-condition-item'">优选题</div>
                        </div>
                    </div>
                    <!-- 来源 -->
                    <div class="ques-condition-container" v-if="quesSourceList&&quesSourceList.length>0">
                        <div class="ques-condition-title">来源：</div>
                        <div class="ques-condition-content">
                            <div @click="changeSourceType(0)" :class="sourceType===0?'ques-condition-item-active':'ques-condition-item'">全部</div>
                            <div @click="changeSourceType(item.key)" :class="sourceType===item.key?'ques-condition-item-active':'ques-condition-item'" v-for="item in quesSourceList" :key="item">{{item.value}}</div>
                        </div>
                    </div>
                    <!-- 年份 -->
                    <div class="ques-condition-container" v-if="quesYearList&&quesYearList.length>0">
                        <div class="ques-condition-title">年份：</div>
                        <div class="ques-condition-content">
                            <div @click="changeQuesYear('')" :class="quesYear===''?'ques-condition-item-active':'ques-condition-item'">全部</div>
                            <div @click="changeQuesYear(item.value)" :class="quesYear===item.value?'ques-condition-item-active':'ques-condition-item'" v-for="item in quesYearList" :key="item">{{item.name}}</div>
                        </div>
                    </div>
                    <!-- 能力 -->
                    <div class="ques-condition-container" v-if="quesAbilityList&&quesAbilityList.length>0">
                        <div class="ques-condition-title">能力：</div>
                        <div class="ques-condition-content">
                            <div @click="changeQuesAbility('')" :class="selTopicNo===''?'ques-condition-item-active':'ques-condition-item'">全部</div>
                            <div @click="changeQuesAbility(item.key)" :class="selTopicNo===item.key?'ques-condition-item-active':'ques-condition-item'" v-for="item in quesAbilityList" :key="item">{{item.value}}</div>
                        </div>
                    </div>
                    <!-- 排序 -->
                    <div class="ques-condition-container" v-if="quesDegreeList&&quesDegreeList.length>0">
                        <div class="ques-condition-title">排序：</div>
                        <div class="ques-condition-content">
                            <div @click="changeQuesSort(0)" :class="queryQues.po===0?'ques-condition-item-active':'ques-condition-item'">
                                综合排序
                                <img v-if="queryQues.po===0&&queryQues.pd===0" class="sort-img" src="../../assets/icon/img/sort_up.png" alt="">
                                <img v-if="queryQues.po===0&&queryQues.pd===1" class="sort-img" src="../../assets/icon/img/sort_down.png" alt="">
                            </div>
                            <div @click="changeQuesSort(1)" :class="queryQues.po===1?'ques-condition-item-active':'ques-condition-item'">
                                组卷次数
                                <img v-if="queryQues.po===1&&queryQues.pd===0" class="sort-img" src="../../assets/icon/img/sort_up.png" alt="">
                                <img v-if="queryQues.po===1&&queryQues.pd===1" class="sort-img" src="../../assets/icon/img/sort_down.png" alt="">
                            </div>
                            <div @click="changeQuesSort(2)" :class="queryQues.po===2?'ques-condition-item-active':'ques-condition-item'">
                                引用次数
                                <img v-if="queryQues.po===2&&queryQues.pd===0" class="sort-img" src="../../assets/icon/img/sort_up.png" alt="">
                                <img v-if="queryQues.po===2&&queryQues.pd===1" class="sort-img" src="../../assets/icon/img/sort_down.png" alt="">
                            </div>
                            <div @click="changeQuesSort(3)" :class="queryQues.po===3?'ques-condition-item-active':'ques-condition-item'">
                                试题难度
                                <img v-if="queryQues.po===3&&queryQues.pd===0" class="sort-img" src="../../assets/icon/img/sort_up.png" alt="">
                                <img v-if="queryQues.po===3&&queryQues.pd===1" class="sort-img" src="../../assets/icon/img/sort_down.png" alt="">
                            </div>
                        </div>
                    </div>
                    <!-- 试题数量 -->
                    <div class="ques-count">共计<span style="color: red;">{{quesCount}}</span>道试题</div>
                    <!-- 试题列表 -->
                    <div class="ques-list-container">
                        <div :class="basketQuesIds.includes(item.sid)?'ques-item-active':'ques-item'" v-for="(item,indexs) in quesList" :key="item.sid">
                            <!-- 试题内容 -->
                            <div class="pt1" >
                                <span class="qseq">{{indexs+1}}．</span>
                                <a v-if="item.label">{{item.label}}</a>
                                <span v-html="item.content"></span>
                            </div>
                            <!-- 选项 -->
                            <div class="pt2" v-if="item.options&&item.options.length>0>0&&item.options[0].length<10">
                                <table style="width:100%" class="ques quesborder">
                                    <tr>
                                        <td style="width:23%" class="selectoption" v-for="(option,oIndexs) in item.options" :key="option">
                                            <div class="cursor" v-if="oIndexs===0">A．<span v-html="option"></span></div>
                                            <div class="cursor"  v-if="oIndexs===1">B．<span v-html="option"></span></div>
                                            <div class="cursor"  v-if="oIndexs===2">C．<span v-html="option"></span></div>
                                            <div class="cursor"  v-if="oIndexs===3">D．<span v-html="option"></span></div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="pt2" v-if="item.options&&item.options.length>0&&item.options[0].length>=10">
                                <table style="width:100%" class="ques quesborder">
                                    <tr v-for="(option,oIndexs) in item.options" :key="option">
                                        <td style="width:98%" class="selectoption" >
                                            <div class="cursor"  v-if="oIndexs===0">A．<span v-html="option"></span></div>
                                            <div class="cursor"  v-if="oIndexs===1">B．<span v-html="option"></span></div>
                                            <div class="cursor"  v-if="oIndexs===2">C．<span v-html="option"></span></div>
                                            <div class="cursor"  v-if="oIndexs===3">D．<span v-html="option"></span></div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="fieldtip">
                                <div class="fieldtip-left">
                                    <span>更新：{{jyeooDate(item.date)}}</span>
                                    <span title="“组卷次数”指试题在用户组卷过程中被使用的次数。次数越多，试题热度越高；次数越少，试题热度越低。">组卷：{{item.paperCount}}</span>
                                    <span title="“引用次数”指试题在大型考试中出现的次数。次数越多，试题常考指数越高；次数越少，试题常考指数越低。">引用：{{item.realCount}}</span>
                                    <span title="“难度系数(系数值区间为0~1)”反映试题的难易程度。系数值越大，试题就越容易；系数值越小，试题难度越大">难度：{{item.degree}}</span>
                                </div>
                                <div class="fieldtip-right">
                                    <a v-if="!basketQuesIds.includes(item.sid)" title="加入试题篮"  style="height: 20px" href="javascript:void(0)" class="btn" @click="handleQuesAddBasket(item)">+试题篮</a>
                                    <a v-if="basketQuesIds.includes(item.sid)" title="从试题篮删除" style="height: 20px;background-color: #f56c6c;" href="javascript:void(0)" class="btn"  @click="handleQuesDelBasket(item)">-试题篮</a>
                                </div>
                            </div>
                        </div>
                        <data-empty v-if="quesList&&quesList.length===0" title="暂无试题"/>
                    </div>
                    <div class="paper-page-container" v-if="quesList&&quesList.length>0">
                        <pageTag :background="true"
                                 :pageSizes="[5, 10]"
                                 v-show="quesCount > 0"
                                 :total="quesCount"
                                 v-model:page.sync="queryQues.pi"
                                 v-model:limit.sync="queryQues.ps"
                                 @pagination="queryQuesList" />
                    </div>
                </el-scrollbar>
            </div>
        </div>
        <!-- 试题篮固定钉 -->
        <div class="paper-affix-container" @click="openPaperBasket">
            <div class="affix-img">
                <svg t="1776236772365" class="icon" viewBox="0 0 1597 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5428" width="32" height="32"><path d="M737.4848 941.75232l-410.50112 2.12992-56.97536-715.5712c0-22.69184-22.528-45.38368-45.01504-45.38368H67.584C22.528 182.92736 0 205.6192 0 251.00288c0 45.38368 22.528 68.07552 67.50208 68.07552h112.47616l67.50208 680.87808c0 22.69184 0 22.69184 22.48704 22.69184h22.528l444.94848 1.2288v-82.1248zM517.44768 160.23552h89.98912v90.76736h-89.98912V160.23552z m134.9632 22.69184h382.44352v45.38368h-382.44352V182.92736z m359.95648 521.99424l-89.98912-90.80832v90.80832l89.98912 68.07552 179.97824-158.88384v-90.76736l-179.97824 181.53472zM517.44768 341.77024h89.98912v90.80832h-89.98912V341.77024z m134.9632 22.7328h382.44352v45.38368h-382.44352V364.50304z m-134.9632 158.84288h89.98912v68.07552h-89.98912v-68.07552z m134.9632 22.69184h202.46528v45.38368h-202.46528v-45.38368z" fill="#ffbf6b" p-id="5429"></path><path d="M832.38912 750.30528h-359.91552c-22.528 0-22.528 0-22.528-22.69184V92.16c0-22.69184 0-22.69184 22.528-22.69184h629.88288c22.528 0 22.528 0 22.528 22.69184v340.3776c0 22.7328 0 22.7328 22.44608 22.7328 22.528 0 22.528 0 22.528-22.69184V46.6944c0-22.69184-22.528-45.38368-45.01504-45.38368H427.45856c-22.48704 22.7328-22.48704 22.7328-22.48704 45.42464v703.52896c0 22.69184 0 45.38368 22.528 45.38368h382.40256c45.01504 0 45.01504 0 45.01504-22.69184s0-22.69184-22.528-22.69184z" fill="#ffbf6b" p-id="5430"></path><path d="M1229.37344 941.8752l97.93536-713.5232c0-22.7328 22.528-45.42464 45.01504-45.42464h157.45024c44.97408 0 67.50208 45.38368 67.50208 68.07552 0 45.38368-45.01504 68.07552-67.50208 68.07552h-112.47616l-112.47616 680.87808c0 22.69184 0 22.69184-22.528 22.69184L737.15712 1024v-82.1248h492.25728z" fill="#ffbf6b" p-id="5431"></path></svg>
            </div>
            <div class="affix-title">
                试题篮
            </div>
            <div class="ques-count-container">{{this.basketQuesCount}}</div>
        </div>

    </div>

    <!-- 试题篮抽屉 -->
    <el-drawer title="试题篮"
               custom-class="drawer-no-style"
               :with-header="false"
               direction="rtl" size="640"
               v-model="isShowPaperDrawer">
        <div class="basket-container">
            <div class="basket-data-container">
                <div class="basket-head-title">
                    试题篮
                </div>
                <div class="basket-head-data">
                    <div class="data1">共计<span style="color: #f56c6c;padding: 0 5px 0 5px;">{{this.basketQuesCount}}</span>题</div>
                    <div class="data2" @click="clearUserBasket">清空全部</div>
                    <div class="data3" @click="paperCenter">进入组卷中心</div>
                </div>
                <div class="basket-classify-data" v-if="quesClassifyList&&quesClassifyList.length>0">
                    <div class="basket-classify-one" v-for="item in quesClassifyList" :key="item">
                        {{item.quesCateName}}
                        <span class="basket-num-span">{{item.quesCount}}</span>
                        <svg @click="handleQuesDelBasketByCate(item.quesCate,item.quesCateName)" t="1776318830644" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5396" width="20" height="20"><path d="M851.316364 284.858182H171.985455a32.349091 32.349091 0 1 0 0 64.698182h75.031272v397.498181a139.496727 139.496727 0 0 0 139.264 139.403637h250.740364a139.496727 139.496727 0 0 0 139.310545-139.403637V349.463273h74.984728a32.349091 32.349091 0 1 0 0-64.698182v0.046545z m-380.555637 396.846545a32.349091 32.349091 0 0 1-64.698182 0V478.487273a32.349091 32.349091 0 1 1 64.698182 0v203.264z m146.385455 0a32.349091 32.349091 0 0 1-64.698182 0V478.487273a32.349091 32.349091 0 0 1 64.698182 0v203.264zM387.816727 250.926545h247.714909a32.395636 32.395636 0 0 0 0-64.744727H387.816727a32.395636 32.395636 0 0 0 0 64.744727z" fill="#0d54a4" p-id="5397"></path></svg>
                    </div>
                </div>
            </div>
            <el-scrollbar class="basket-scrollbar-container">
                <div class="basket-title-container">
                    {{basketInfo.basketName}}
                </div>
                <div  v-for="(parItem,index) in quesClassifyList" :key="parItem">
                    <div class="ques-classify-title">
                        {{quesNoList[index]}}{{parItem.quesCateName}}（共{{parItem.quesCount}}小题）
                    </div>
                    <div class="ques-list-container-drawer">
                        <div class="ques-item-drawer" v-for="(item,indexs) in parItem.quesList" :key="item.ques.sid">
                            <!-- 试题内容 -->
                            <div class="pt1" >
                                <span class="qseq">{{indexs+1}}．</span>
                                <a v-if="item.ques.label">{{item.ques.label}}</a>
                                <span v-html="item.ques.content"></span>
                            </div>
                            <!-- 选项 -->
                            <div class="pt2" v-if="item.ques.options&&item.ques.options.length>0>0&&item.ques.options[0].length<10">
                                <table style="width:100%" class="ques quesborder">
                                    <tr>
                                        <td style="width:23%" class="selectoption" v-for="(option,oIndexs) in item.ques.options" :key="option">
                                            <div class="cursor" v-if="oIndexs===0">A．<span v-html="option"></span></div>
                                            <div class="cursor"  v-if="oIndexs===1">B．<span v-html="option"></span></div>
                                            <div class="cursor"  v-if="oIndexs===2">C．<span v-html="option"></span></div>
                                            <div class="cursor"  v-if="oIndexs===3">D．<span v-html="option"></span></div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="pt2" v-if="item.ques.options&&item.ques.options.length>0&&item.ques.options[0].length>=10">
                                <table style="width:100%" class="ques quesborder">
                                    <tr v-for="(option,oIndexs) in item.ques.options" :key="option">
                                        <td style="width:98%" class="selectoption" >
                                            <div class="cursor"  v-if="oIndexs===0">A．<span v-html="option"></span></div>
                                            <div class="cursor"  v-if="oIndexs===1">B．<span v-html="option"></span></div>
                                            <div class="cursor"  v-if="oIndexs===2">C．<span v-html="option"></span></div>
                                            <div class="cursor"  v-if="oIndexs===3">D．<span v-html="option"></span></div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="fieldtip" style="border: none!important;">
                                <div class="fieldtip-left">
                                </div>
                                <div class="fieldtip-right">
                                    <a title="从试题篮删除" style="height: 20px;background-color: #f56c6c;" href="javascript:void(0)" class="btn"  @click="handleQuesDelBasket(item.ques)">删除</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-scrollbar>
        </div>
    </el-drawer>
</template>

<script>
import {timestampToTime} from "@/utils/date";
import {jyeooDate} from "@/utils/str"
import {
    listSubject, listEdition, listGrade, listQuesAbility, listPoint,
    listBook, listCategory, listQuesType, listQuesSource, listQuestion,
    queryBasket, quesAddBasket, checkJyeooToken, clearBasket, quesDelBasket,
    delQuesByCate, userPaperSubject,
} from "@/api/admin/paper";
import pageTag from "@/components/Pagination/page.vue";
import dataEmpty from "@/components/dataEmpty.vue";

export default {
    name: "HomeExamPaper",
    components: {dataEmpty, pageTag},
    data() {
        return {
            loading:true,
            isShowPaperDrawer:false,
            timestampToTime,
            jyeooDate,
            userInfo : JSON.parse(this.$storage.get("userInfo")),
            paperMode:1,// 1-章节选题  2-知识点选题
            subjectPeriod:"",// 学段标识
            periodName:"",
            subjectList:[],// 学科列表
            allowSubjects:[],// 当前用户已授权的学科英文名称（角色1/2不限制）
            subjectInfo:{},
            subjectNo:'',
            subjectEnName:'',
            editionList:[], // 教材版本列表
            editionInfo:{},
            editionNo:'',
            editionName:'',
            queryGrade:{
                gradeSubject:'',
                editionNo:'',
            },
            gradeList:[], // 教材版本年级列表
            gradeInfo:{},
            gradeNo:'',
            termNo:'',
            gradeName:'',
            gradeOtherName:'',
            queryBook:{
                bookSubject:'',
                editionId:'',
                gradeId:'',
                termId:'',
            },
            bookList:[],
            bookInfo:{},
            bookId:'',
            categoryList:[],// 章节列表
            categoryProps:{
                children: "children",
                label: "categoryName",
            },
            quesTypeList:[],// 题型列表
            // 难度列表
            quesDegreeList:[
                { name: '易', value: 11 },
                { name: '较易', value: 12 },
                { name: '中档', value: 13 },
                { name: '较难', value: 14 },
                { name: '难', value: 15 },
            ],
            quesSourceList:[],// 试题来源列表
            // 年份
            quesYearList:[
                { name: '2026', value: '2026' },
                { name: '2025', value: '2025' },
                { name: '2024', value: '2024' },
                { name: '2023', value: '2023' },
                { name: '2022', value: '2022' },
                { name: '更早', value: '2021,2020,2019,2018,2017,2016,2015' },
            ],
            quesAbilityList:[],// 能力列表
            // 查询试题
            queryQues:{
                subject: "", // 学科
                tp: 1, // 类别（1：按教材；2：按考点；3：按专题）
                p1: "", // 教材标识（当tp=2时无效，传0或空即可）
                p2: "", // 教材下的章节标识（当tp=2时无效，传0或空即可）
                p3: "", // 考点编号（多个以逗号分隔，当tp=1时可传空）
                dg: 0, // 难度（0：不限；11：易（0.8到1.0）；12：较易（0.6到0.8）；13：中档（0.4到0.6）；14：较难：（0.2到0.4）；15：难：（0.0到0.2）（大于等于；小于））
                ct: 0, // 题型（传0则表示不限制）
                ct2: 0, // 二级题型（传0则表示不限制）
                yc: "False", // 压轴题（True：压轴题；False：不限）
                ec: "False", // 易错题（True：易错题；False：不限）
                gc: "False", // 好题集（True：好题；False：不限）
                sc: "False", // 真题优选集（True：真题；False：不限）
                rc: "False", // 常考题（True：常考题；False：不限）
                kb: 0, // 是否课本原题（0：不限；1：是（默认0））
                kw: "", // 关键词
                rg: "", // 地区编码（传空则不限）
                so: 0, // 试题来源（传空或0则不限，多个以逗号分隔）
                topicNo: "", // 专题或能力标识（传空则不限）
                yr: "", // 试题年份（如：2023，传空或0则不限，多个以逗号分隔）
                po: 0, // 0：综合排序；1：组卷次数；2：真题次数；3：试题难度（默认0）
                pd: 0, // 0：升序；1：降序（默认1）
                pi: 1, // 当前页（以1开始）
                ps: 10, //每页记录数（小于等于10）
            },
            quesCount:0, // 试题总数量
            quesList:[], // 实体列表
            totalPage:0 , // 总页数
            // 查询考点
            pointList:[],
            pointProps:{
                children: "children",
                label: "name",
            },
            // 筛选条件
            selCategoryId:'',
            selPointNo:'',
            quesType:0,
            degreeType:0,
            sourceType:0,
            quesYear:'', // 年份
            selTopicNo:'', // 能力
            quesClassify:'True',// 题类
            // 试题篮
            addQues:{
                basketSubject:'',
                ques:null,
            },
            basketInfo:{},
            basketQuesCount:0,
            basketId:"",
            basketQuesIds:"",
            quesClassifyList:[],// 试题分类列表
            quesNoList:[
              "一．", "二．", "三．", "四．","五．",
              "六．", "七．", "八．", "九．", "十．",
              "十一．", "十二．", "十三．", "十四．", "十五．",
            ],
            delQuesCateForm:{
                basketId:'',
                quesCate:'',
            }
        };
    },
    created() {
        if (this.$route.query.sp) {
            this.subjectPeriod = this.$route.query.sp;
            this.checkUserJyeooToken();
        }
    },
    mounted() {
    },
    activated() {
        // 从组卷中心返回时保留筛选条件；学段变化则重新初始化加载
        // 注意：组件被 keep-alive 缓存，不能用 reload()（v-if 切换不会重建缓存实例，会导致死循环）
        const sp = this.$route.query.sp;
        if (sp && sp !== this.subjectPeriod) {
            this.subjectPeriod = sp;
            this.loading = true;
            this.paperMode = 1;
            this.queryQues.tp = 1;
            this.queryQues.pi = 1;
            this.queryQues.ps = 10;
            this.resetSearch();
            this.resetBasket();
            this.resetQues();
            this.checkUserJyeooToken();
        }
    },
    watch: {
    },
    methods: {
        // 查验Token
        checkUserJyeooToken(){
            checkJyeooToken().then(res => {
                if (res.data.code === 1) {
                    this.matchPeriodName();
                    const role = this.$storage.get("role");
                    if (role == 1 || role == 2) {
                        // 角色1/2不限制学科
                        this.querySubjectList();
                    } else {
                        // 查询用户授权学科后再加载学科列表
                        userPaperSubject({ userId: this.userInfo.userId }).then(r => {
                            if (r.data.code === 1) {
                                this.allowSubjects = (r.data.data || "").toString().split(",").map(s => s.trim()).filter(Boolean);
                            }
                            this.querySubjectList();
                        }).catch(() => {
                            this.querySubjectList();
                        });
                    }
                }
            });
        },
        // 组卷中心
        paperCenter(){
            this.$router.push({
                path: "/hyedu/paper",
                query: {
                    sp: this.subjectPeriod,
                    sen: this.subjectEnName,
                }
            });
        },
        // 切换选题模式
        changePaperMode(mode){
            if (mode === this.paperMode){
                return;
            }
            this.paperMode = mode;
            this.queryQues.pi = 1;
            this.queryQues.ps = 10;
            this.queryQues.p1 = '';
            this.queryQues.p2 = '';
            this.queryQues.p3 = '';
            this.quesCount=0; // 试题总数量
            this.quesList=[]; // 实体列表
            this.totalPage=0;
            if (this.paperMode===1){
                this.queryQues.tp = 1;
                this.queryEditionList();
            }
            if (this.paperMode===2){
                this.queryQues.tp = 2;
                this.queryPointList();
            }
        },
        // 打开试题篮
        openPaperBasket(){
            this.isShowPaperDrawer = true;
        },
        // 返回资源中心（定位到教师发展中心Tab）
        backResourceCenter(path){
            this.$store.commit("params/setJumpParams", { activeTab: 'teacher' });
            this.$router.push(path);
        },
        // 匹配学段资源
        matchPeriodName(){
            if (this.subjectPeriod === '1'){
                this.periodName = '小学资源'
            }
            if (this.subjectPeriod === '2'){
                this.periodName = '初中资源'
            }
            if (this.subjectPeriod === '3'){
                this.periodName = '高中资源'
            }
        },
        // 切换学科
        changeSubject(item){
            this.queryQues.pi = 1;
            this.queryQues.ps = 10;
            this.subjectInfo = item;
            this.subjectNo = this.subjectInfo.subjectNo;
            this.subjectEnName = this.subjectInfo.subjectEnName;
            this.queryQues.subject = this.subjectInfo.subjectEnName;
            this.resetSearch();
            this.resetBasket();
            this.resetQues();
            this.queryQuesTypeList();
            this.queryQuesSourceList();
            this.queryQuesAbilityList();
            this.queryBasketInfo();
            if (this.paperMode===1){
                this.queryQues.tp = 1;
                this.queryEditionList();
            }
            if (this.paperMode===2){
                this.queryQues.tp = 2;
                this.queryPointList();
                this.queryQuesList();
            }
        },
        // 切换版本
        changeEdition(item){
            this.resetSearch();
            this.editionNo = null;
            this.termNo = null;
            this.gradeNo = null;
            this.editionInfo = item;
            this.editionNo = this.editionInfo.editionNo;
            this.editionName = this.editionInfo.editionName;
            this.queryGradeList();
        },
        // 切换年级
        changeGrade(item){
            this.resetSearch();
            this.gradeInfo = item;
            this.gradeNo = this.gradeInfo.gradeNo;
            this.termNo = this.gradeInfo.termNo;
            this.gradeName = this.gradeInfo.gradeName;
            this.gradeOtherName = this.gradeInfo.gradeOtherName;
            this.queryBookList();
        },
        // 切换条件-题型
        changeQuesType(qt){
            this.quesType = qt;
            this.queryQues.ct = qt;
            this.queryQuesList();
        },
        // 切换条件-难度
        changeDegreeType(dg){
            this.degreeType = dg;
            this.queryQues.dg = dg;
            this.queryQuesList();
        },
        // 切换条件-来源
        changeSourceType(so){
            this.sourceType = so;
            this.queryQues.so = so;
            this.queryQuesList();
        },
        // 切换条件-年份
        changeQuesYear(yr){
            this.quesYear = yr;
            this.queryQues.yr = yr;
            this.queryQuesList();
        },
        // 切换条件-题类
        changeQuesClassify(no){
            this.quesClassify = "False"
            this.queryQues.rc = "False";
            this.queryQues.ec = "False";
            this.queryQues.gc = "False";
            this.queryQues.yc = "False";
            this.queryQues.sc = "False";
            if (no === 0){
                this.quesClassify = "True"
            }
            if (no === 1){
                this.queryQues.rc = "True"
            }
            if (no === 2){
                this.queryQues.ec = "True"
            }
            if (no === 3){
                this.queryQues.gc = "True"
            }
            if (no === 4){
                this.queryQues.yc = "True"
            }
            if (no === 5){
                this.queryQues.sc = "True"
            }
            this.queryQuesList();
        },
        // 切换条件-能力
        changeQuesAbility(topicNo){
            this.selTopicNo = topicNo;
            this.queryQues.topicNo = topicNo;
            this.queryQuesList();
        },
        // 切换条件-排序
        changeQuesSort(po){
            if (this.queryQues.po === po){
                if (this.queryQues.pd === 1){
                    this.queryQues.pd = 0
                }else {
                    this.queryQues.pd = 1;
                }
            }else {
                this.queryQues.po = po;
                this.queryQues.pd = 0;
            }
            this.queryQuesList();
        },
        // 重置搜索条件
        resetSearch(){
            this.queryQues.dg = 0;
            this.queryQues.ct = 0;
            this.queryQues.kb = 0;
            this.queryQues.so = 0;
            this.queryQues.yc = "False";
            this.queryQues.ec = "False";
            this.queryQues.gc = "False";
            this.queryQues.sc = "False";
            this.queryQues.rc = "False";
            this.queryQues.kw = "";
            this.queryQues.rg = "";
            this.queryQues.topicNo = '';
            this.queryQues.po = 0;
            this.queryQues.pd = 0;
            this.selCategoryId='';
            this.selPointNo='';
            this.quesType=0;
            this.degreeType=0;
            this.sourceType=0;
            this.quesYear='';
            this.quesClassify='True';
            this.selTopicNo = '';

        },
        // 重试试题篮
        resetBasket(){
            this.basketInfo={};
            this.basketQuesCount=0;
            this.basketQuesIds="";
            this.basketId="";
            this.quesClassifyList=[];
        },
        // 重试试题
        resetQues(){
            this.quesCount=0;
            this.quesList=[];
            this.totalPage=0 ;
        },
        // 选中章节
        handleCategoryNodeClick(e){
            this.queryQues.p2 = e.categoryId;
            this.selCategoryId = e.categoryId;
            this.queryQuesList();
        },
        // 选中考点
        handlePointNodeClick(e){
            this.queryQues.p3 = e.no;
            this.selPointNo = e.no;
            this.queryQuesList();
        },
        // 查询学科
        querySubjectList(){
            listSubject({ subjectPeriod: this.subjectPeriod }).then(res => {
                if (res.data.code === 1) {
                    this.subjectList = res.data.data;
                    const role = this.$storage.get("role");
                    if (!(role == 1 || role == 2)) {
                        // 仅保留已授权的学科（subjectEnName 完全相等）
                        this.subjectList = (this.subjectList || []).filter(item => this.allowSubjects.includes(item.subjectEnName));
                        if (this.subjectList.length === 0) {
                            this.loading = false;
                            this.$message({ message: '暂未授权学科，请联系管理员', type: 'warning' });
                            return;
                        }
                    }
                    if (this.subjectList&&this.subjectList.length>0){
                        this.subjectInfo = this.subjectList[0];
                        this.subjectNo = this.subjectInfo.subjectNo;
                        this.subjectEnName = this.subjectInfo.subjectEnName;
                        this.queryQues.subject = this.subjectInfo.subjectEnName;
                        this.queryQuesTypeList();
                        this.queryQuesSourceList();
                        this.queryQuesAbilityList();
                        this.queryBasketInfo();
                        if (this.paperMode===1){
                            this.queryQues.tp = 1;
                            this.queryEditionList();
                        }
                        if (this.paperMode===2){
                            this.queryQues.tp = 2;
                            this.queryPointList();
                            this.queryQuesList();
                        }
                    }
                }else {
                    this.$message.error("请求出错")
                }
            });
        },
        // 查询教材版本
        queryEditionList(){
            listEdition({ subjectEnName: this.subjectEnName }).then(res => {
                if (res.data.code === 1) {
                    this.editionList = res.data.data;
                    if (this.editionList&&this.editionList.length>0){
                        this.editionInfo = this.editionList[0];
                        this.editionNo = this.editionInfo.editionNo;
                        this.editionName = this.editionInfo.editionName;
                        this.queryGradeList();
                    }
                }else {
                    this.$message.error("请求出错")
                }
            });
        },
        // 查询教材相关年级
        queryGradeList(){
            this.queryGrade.editionNo = this.editionNo;
            this.queryGrade.gradeSubject = this.subjectEnName;
            listGrade(this.queryGrade).then(res => {
                if (res.data.code === 1) {
                    this.gradeList = res.data.data;
                    if (this.gradeList&&this.gradeList.length>0){
                        this.gradeInfo = this.gradeList[0];
                        this.gradeNo = this.gradeInfo.gradeNo;
                        this.termNo = this.gradeInfo.termNo;
                        this.gradeName = this.gradeInfo.gradeName;
                        this.gradeOtherName = this.gradeInfo.gradeOtherName;
                        this.queryBookList();
                    }
                }else {
                    this.$message.error("请求出错")
                }
            });
        },
        // 查询教材
        queryBookList(){
            this.queryBook.bookSubject = this.subjectEnName;
            this.queryBook.editionId = this.editionNo;
            this.queryBook.gradeId = this.gradeNo;
            this.queryBook.termId = this.termNo;
            listBook(this.queryBook).then(res => {
                if (res.data.code === 1) {
                    this.bookList = res.data.data;
                    if (this.bookList&&this.bookList.length>0){
                        this.bookInfo = this.bookList[0];
                        this.bookId = this.bookInfo.bookId;
                        this.queryQues.p1 = this.bookInfo.bookId;
                        this.queryBookCategory();
                        this.queryQuesList();
                    }
                }else {
                    this.$message.error("请求出错")
                }
            });
        },
        // 查询教材章节
        queryBookCategory(){
            listCategory({ bookId: this.bookId }).then(res => {
                if (res.data.code === 1) {
                    this.categoryList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            });
        },
        // 查询题型列表
        queryQuesTypeList(){
            listQuesType({ subjectEnName: this.subjectEnName }).then(res => {
                if (res.data.code === 1) {
                    this.quesTypeList = res.data.data;
                }else {
                    // this.$message.error("请求出错")
                }
            });
        },
        // 查询来源列表
        queryQuesSourceList(){
            listQuesSource({ subjectEnName: this.subjectEnName }).then(res => {
                if (res.data.code === 1) {
                    this.quesSourceList = res.data.data;
                }else {
                    // this.$message.error("请求出错")
                }
            });
        },
        // 查询能力列表
        queryQuesAbilityList(){
            listQuesAbility({ subjectEnName: this.subjectEnName }).then(res => {
                if (res.data.code === 1) {
                    this.quesAbilityList = res.data.data;
                }else {
                    // this.$message.error("请求出错")
                }
            });
        },
        // 查询试题列表
        queryQuesList(){
            this.loading = true;
            this.quesCount = 0;
            this.quesList = [];
            this.totalPage = 0;
            listQuestion(this.queryQues).then(res => {
                if (res.data.code === 1) {
                    this.quesCount = res.data.data.count;
                    this.quesList = res.data.data.data;
                    this.totalPage = res.data.data.totalPage;
                    this.loading = false;
                }else {
                    // this.$message.error("请求出错")
                    this.loading = false;
                }
            });
        },
        // 查询考点列表
        queryPointList(){
            this.loading = true;
            this.pointList = []
            listPoint({ subjectEnName: this.subjectEnName }).then(res => {
                if (res.data.code === 1) {
                    this.pointList = res.data.data;
                    if (this.pointList&&this.pointList.length>0) {
                        this.selPointNo = this.pointList[0].no;
                        this.queryQues.p3 = this.selPointNo;
                        this.queryQuesList();
                    }
                    this.loading = false;
                }else {
                    this.loading = false;
                    // this.$message.error("请求出错")
                }
            });
        },
        // 试题加入试题篮
        handleQuesAddBasket(q){
            this.addQues.ques = q;
            this.addQues.basketSubject = this.subjectEnName;
            quesAddBasket(this.addQues).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("试题已添加")
                    this.queryBasketInfo();
                }else {
                    this.$message.error("请求出错")
                }
            });
        },
        // 试题从试题篮删除
        handleQuesDelBasket(q){
            this.addQues.ques = q;
            this.addQues.basketSubject = this.subjectEnName;
            quesDelBasket(this.addQues).then(res => {
                if (res.data.code === 1) {
                    this.$message.info("试题已移除")
                    this.queryBasketInfo();
                }else {
                    this.$message.error("请求出错")
                }
            });
        },
        // 试题从试题篮删除（按类型）
        handleQuesDelBasketByCate(cate,cateName){
            if (!this.basketId){
                return;
            }
            this.$confirm("您正在删除"+cateName+"，是否继续？", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "success"
            }).then(() => {
                this.delQuesCateForm.quesCate = cate;
                this.delQuesCateForm.basketId = this.basketId;
                delQuesByCate(this.delQuesCateForm).then(res => {
                    if (res.data.code === 1) {
                        this.$message.info(cateName+"已移除")
                        this.queryBasketInfo();
                    }else {
                        this.$message.error("请求出错")
                    }
                });
            }).catch(()=>{

            })
        },
        // 查询试题篮
        queryBasketInfo(){
            this.resetBasket();
            queryBasket({ subjectEnName: this.subjectEnName }).then(res => {
                if (res.data.code === 1) {
                    this.basketInfo = res.data.data;
                    this.basketId = this.basketInfo.basketId;
                    this.basketQuesCount = this.basketInfo.quesCount;
                    this.basketQuesIds = this.basketInfo.quesIds;
                    this.quesClassifyList = this.basketInfo.qcList;
                }
            });
        },
        // 清空用户试题篮
        clearUserBasket(){
            if (!this.basketId){
                return;
            }
            this.$confirm("您正在清空试题篮，是否继续？", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "success"
            }).then(() => {
                clearBasket({ basketId: this.basketId }).then(res => {
                    if (res.data.code === 1) {
                        this.queryBasketInfo();
                        this.$message.error("试题篮已清空")
                    }else {
                        this.$message.error("请求出错")
                    }
                });
            }).catch(()=>{

            })

        },
        //
    }
};
</script>
<style lang="less" scoped>
.base-paper-container{
    width: 100%;
    background-color: #fff;
    height: 100vh;
}
.paper-head-box{
    width: 100%;
    height: 52px;
}
.paper-head-container{
    height: 50px;
    width: 100%;
    line-height: 48px;
    box-shadow: 0 1px 12px 0 rgba(0, 58, 129, 0.08);
    background-color: #fff;
    display: flex;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.l-side-paper-container{
    width: 60px;
    height: 50px;
}
.r-side-paper-container{
    width: 60px;
    height: 50px;
}
.mid-paper-container{
    width: calc(100% - 120px);
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    color: #0d55a4;
    font-weight: bold;
    font-family: sans-serif;
    text-align: center;
}
.paper-container{
    width: 100%;
    background-color: #f5f5f5;
    height: calc(100vh - 52px);
    display: flex;
}
/*左侧内容*/
.l-paper-container{
    width: 250px;
    background-color: #fff;
    height: calc(100vh - 52px);
    display: flex;
}
.l-scrollbar-container{
    width: 100%;
    height: calc(100vh - 58px);
}
.subject-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    color: #0d55a4;
    padding: 0 0 0 10px;
    box-sizing: border-box;
}
.subject-box-container{
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    box-shadow: 0 1px 12px 0 rgba(0, 58, 129, 0.08);
    padding: 0 0 10px 10px;
    box-sizing: border-box;
}
.subject-one{
    width: auto;
    height: 24px;
    line-height: 24px;
    padding: 0 5px 0 5px;
    margin-right: 5px;
    margin-top: 5px;
    border: .5px solid #333;
    cursor: pointer;
    font-size: 12px;
    border-radius: 4px;
    color: #333;
}
.subject-one-active{
    width: auto;
    height: 24px;
    line-height: 24px;
    padding: 0 5px 0 5px;
    margin-right: 5px;
    margin-top: 5px;
    border: .5px solid #0d55a4;
    color: #fff;
    background-color: #0d55a4;
    cursor: pointer;
    font-size: 12px;
    border-radius: 4px;
}
/*版本信息*/
.edition-container{
    width: 100%;
    height: auto;
    display: flex;
    padding: 10px 0 10px 0;
    box-shadow: 0 1px 12px 0 rgba(0, 58, 129, 0.08);
    cursor: pointer;
}
.l-edition-container{
    width: calc(100% - 40px);
    height: auto;
    display: flex;
    font-size: 15px;
    font-weight: bold;
    color: #0d55a4;
    box-sizing: border-box;
    padding: 0 20px 0 10px;
    align-items: center;
}
.r-edition-container{
    width: 40px;
    height: auto;
    display: flex;
    padding-right: 10px;
    box-sizing: border-box;
    align-items: center;
}
.edition-title{
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    color: #000;
}
.edition-grade-container{
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}
.edition-grade-item{
    width: auto;
    height: 24px;
    line-height: 24px;
    padding: 0 5px 0 5px;
    margin-right: 5px;
    margin-top: 5px;
    cursor: pointer;
    font-size: 14px;
    border-radius: 4px;
    color: #333;
}
.edition-grade-item-active{
    width: auto;
    height: 24px;
    line-height: 24px;
    padding: 0 5px 0 5px;
    margin-right: 5px;
    margin-top: 5px;
    color: #fff;
    background-color: #0d55a4;
    cursor: pointer;
    font-size: 14px;
    border-radius: 4px;
}
.edition-divider{
    width: 100%;
    height: 10px;
    border-bottom: 1px solid #dcdfe6;
}
.category-container{
    width: 100%;
    height: auto;
    margin-top: 5px;
}
/*树结构*/
.el-tree /deep/ .el-tree-node__content {
    position: relative;
}
.el-tree /deep/ .el-tree-node__expand-icon {
    display: none !important;
}
/*竖线*/
.el-tree /deep/ .el-tree-node:last-child > .el-tree-node__content::before {
    content: "";
    width: 1px;
    height: 10000px;
    border-width: 1px;
    border-left: 1.5px dashed #d4d4d4;
    position: absolute;
    margin-left: 5px;
    bottom: 13px;
}
/*横线*/
.el-tree /deep/ .el-tree-node__children .el-tree-node__content::after {
    content: "";
    width: 10px;
    height: 1px;
    border-width: 1px;
    border-top: 1.5px dashed #d4d4d4;
    margin-left: 5px;
    position: absolute;
}
.category-tree-node{
    width: 100%;
    padding-left: 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
}
.category-span{
    margin-left: 5px;
    align-items: center;
}
.category-span-active{
    margin-left: 5px;
    align-items: center;
    color: #0d55a4;
}
/*右侧内容*/
.r-paper-container{
    width: calc(100% - 260px);
    margin-left: 10px;
    height: calc(100vh - 52px);
}
/*试卷选题模式*/
.paper-nav-container{
    width: 100%;
    height: 40px;
    display: flex;
    background-color: #fff;
}
.paper-nav-item{
    width: auto;
    height: 38px;
    line-height: 38px;
    padding: 0 10px 0 10px;
    color: #000000;
    font-size: 15px;
    cursor: pointer;
}
.paper-nav-item-active{
    width: auto;
    height: 38px;
    line-height: 38px;
    padding: 0 10px 0 10px;
    color: #0d55a4;
    cursor: pointer;
    font-weight: bold;
    border-bottom: 2px solid #0d55a4;
}
/*试题内容*/
.r-scrollbar-container{
    width: 100%;
    height: calc(100vh - 100px);
    background-color: #fff;
    margin-top: 10px;
    padding-bottom: 30px;
}
.r-scrollbar{
    width: 100%;
    height: calc(100vh - 100px);
}
/*筛选条件*/
.ques-condition-container{
    width: 100%;
    height: auto;
    padding: 10px 0 10px 10px;
    box-sizing: border-box;
    display: flex;
    border-bottom: 1px dotted #dadada;

}
.ques-condition-title{
    width: 70px;
    height: auto;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: 14px;
    color: #999999;
}
.ques-condition-content{
    width: calc(100% - 70px);
    height: auto;
    display: flex;
    font-size: 14px;
    color: #333333;
    flex-wrap: wrap;
    gap: 5px;
}
.ques-condition-item{
    width: auto;
    height: 24px;
    line-height: 24px;
    padding: 0 10px 0 10px;
    margin-right: 5px;
    cursor: pointer;
    font-size: 14px;
    border-radius: 4px;
    color: #333;
    align-items: center;
    justify-content: center;
    display: flex;
}
.ques-condition-item-active{
    width: auto;
    height: 24px;
    line-height: 24px;
    padding: 0 10px 0 10px;
    margin-right: 5px;
    color: #fff;
    background-color: #0d55a4;
    cursor: pointer;
    font-size: 14px;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
    display: flex;
}
.ques-count{
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    padding-right: 20px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333333;
}
.sort-img{
    width: 16px;
    height: 16px;
}
.ques-list-container{
    width: calc(100% - 10px);
    padding: 0 0 0 10px;
    margin: auto;
    box-sizing: border-box;
    height: auto;
}
.ques-item{
    width: calc(100% - 30px);
    height: auto;
    margin-top: auto;
    margin-bottom: 20px;
    border: 1px solid #dadada;
    border-radius: 5px;
}
.ques-item-active{
    width: calc(100% - 30px);
    height: auto;
    margin-top: auto;
    margin-bottom: 20px;
    border: 1px solid #0d55a4!important;
    border-radius: 5px;
    background-color: #dbe6f1!important;
}
.ques-list-container-drawer{
    width: 100% ;
    margin: auto;
    height: auto;
}
.ques-item-drawer{
    width: calc(100% - 4px);
    height: auto;
    margin-top: auto;
    margin-bottom: 10px;
    border-radius: 5px;
    border: 1px solid #dadada;
}
.ques-item:hover{
    border: 1px solid #0d55a4!important;
    border-radius: 5px;
}
.paper-page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 80px;
    padding-bottom: 10px;

}

/*试卷蓝固定钉*/
.paper-affix-container{
    width: 52px;
    height: auto;
    position: fixed; /* 使用fixed定位 */
    right: 20px; /* 固定在右边 */
    top: 180px; /* 距离视口顶部50px */
    z-index: 1000; /* 确保在其他元素之上 */
    padding: 10px 0;
    border-radius: 4px;
    box-shadow: 1px 1px 8px 0 rgba(8, 33, 64, 0.12);
    background-color: #fff;
    cursor: pointer;
}
.affix-img{
    width: 32px;
    height: 32px;
    margin: auto;
}
.affix-title{
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 13px;
    color: #999999;
}
.ques-count-container{
    width: auto;
    height: 18px;
    position: absolute; /* 使用fixed定位 */
    right: -10px; /* 固定在右边 */
    top: -9px; /* 距离视口顶部50px */
    z-index: 2000; /* 确保在其他元素之上 */
    border-radius: 10px;
    background-color: #f56c6c;
    display: inline-block;
    font-size: 12px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    color: #fff;
}

/*试题篮 --el-dialog-padding-primary*/
/deep/ .drawer-no-style .el-drawer__body {
    padding: 0 !important;
}
.basket-container{
    width: 100%;
    height: auto;
}
.basket-data-container{
    width: 100%;
    height: auto;
}

.basket-head-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    padding: 0 0 0 10px;
    border-bottom: 1px solid #dcdfe6;
    color: #0d55a4;
    font-weight: bold;
    box-sizing: border-box;
}
.basket-head-data{
    width: 100%;
    height: 40px;
    padding: 0 20px 0 20px;
    box-sizing: border-box;
    display: flex;
}
.data1{
    float: left;
    height: 40px;
    line-height: 40px;
    width: calc(100% - 200px);
    cursor: pointer;
    color: #666666;
    font-size: 14px;
}
.data2{
    float: right;
    height: 40px;
    line-height: 40px;
    width: 60px;
    margin-right: 40px;
    cursor: pointer;
    color: #666666;
    font-size: 14px;
}
.data2:hover{
    color: #0d55a4;
}
.data3{
    float: right;
    height: 30px;
    width: 100px;
    line-height: 30px;
    background-color: #0d55a4;
    color: #fff;
    cursor: pointer;
    text-align: center;
    border-radius: 6px;
    margin-top: 5px;
    font-size: 13px;
}
.basket-classify-data{
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    box-shadow: 0 1px 12px 0 rgba(0, 58, 129, 0.08);
    padding: 10px 20px 10px 20px;
    box-sizing: border-box;
}
.basket-classify-one{
    width: auto;
    height: 24px;
    line-height: 24px;
    padding: 0 5px 0 10px;
    margin-right: 5px;
    margin-top: 5px;
    border: .5px solid #333;
    cursor: pointer;
    font-size: 13px;
    border-radius: 4px;
    color: #666666;
    align-items: center;
    justify-content: center;
    display: flex;
}
.basket-classify-one:hover{
    border: .5px solid #0d55a4;
    color: #0d55a4;
}
.basket-num-span{
    color: #f56c6c;
    padding: 0 5px 0 5px;
}
.basket-scrollbar-container{
    width: 99%;
    height: auto;
    padding: 0 20px 20px 20px;
    box-sizing: border-box;
}
.basket-title-container{
    width: 100%;
    height: 40px;
    color: #333333;
    line-height: 40px;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
}
.ques-classify-title{
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
}
</style>